import React, { Component } from "react";
import { WidgetTypes } from "../../../constants/QuestionTypes";
import { getRowColumns } from "../../../services/formService";
import InfoViewer from "./Info_Viewer";
import QAViewer from "./QAViewer";

class RowViewer extends Component {
  state = {
    Widget_ID: this.props.Widget_ID,
    SurveyMode: this.props.SurveyMode ? this.props.SurveyMode : false,
    Columns: [],
    Options: [],
    loading: true,
    Question_Number: this.props.Question_Number ? this.props.Question_Number : 0,
    Widget_Color: this.props.Widget_Color ? this.props.Widget_Color : '#0061f2',
    dataElements: this.props.dataElements ? this.props.dataElements : undefined,
		infoConfig: this.props.infoConfig ? this.props.infoConfig : undefined,
		sharedDataElement: this.props.sharedDataElement ? this.props.sharedDataElement : undefined,
  };

  async componentDidMount() {
    let { data: Columns } = await getRowColumns(this.state.Widget_ID);
    let infoConfig = this.state.infoConfig, DEs = this.state.dataElements;
    if (this.state.sharedDataElement > 0) {
      Columns.map((col) => {
      //console.log(col.Column_Widget_ID, infoConfig.some(i => { if (i.Widget_ID === col.Column_Widget_ID) { return true; } }))
        if (infoConfig.some(i => { if (i.Widget_ID === col.Column_Widget_ID) { return true; } })) {
          let Widget_ID = col.Column_Widget_ID,
            resultSource = infoConfig.filter((infoEl) => infoEl.Widget_ID === Widget_ID)[0],
            destDE = DEs.filter((deEl) => deEl.ResultSource_Content === resultSource['ResultSource_Content']);
          col['sharedDataElement'] = destDE || [];
          col['resultSource'] = resultSource;
          return col;
        }
      });
    }
    Columns.length!==0 && this.setState({ Columns });
    this.setState({ loading: false });
  }
  
  render() {
    return (
      <div className="row mb-2 mt-2">
        {
          this.state.Columns.map((col, idx) => (
            <div className="col" key={"V" + col.Column_Widget_ID}>
              {(col.Column_Widget_Type_ID === WidgetTypes.Info) && ( //add col widget type id in the db for these fields
                <InfoViewer
                  key={"V" + col.Column_Widget_ID}
                  Widget_ID={col.Column_Widget_ID}
                  Widget_Type_ID={WidgetTypes.Info}
                  Project_ID={this.props.Project_ID}
                  Widget_Color={col.Widget_Color}
                  Col_ID={col.Column_ID}
                  dataElements={this.state.dataElements}
                  infoConfig={this.state.infoConfig}
                  sharedDataElement={col.sharedDataElement}
                  resultSource={col.resultSource}
                />
              )}
              {(col.Column_Widget_Type_ID === WidgetTypes.QA) && (
                <QAViewer
                  key={"V" + col.Column_Widget_ID}
                  Widget_ID={col.Column_Widget_ID}
                  Question_Number={this.state.Question_Number + idx}
                  Form_ID={this.props.Form_ID}
                  OnUpdate={this.props.OnUpdate}
                  SurveyMode={this.props.SurveyMode}
                  PrimaryKey={this.props.PrimaryKey}
                  Project_ID={this.props.Project_ID}
                  selectedInst={this.props.selectedInst}
                  Widget_Type_ID={WidgetTypes.QA}
                  isRow={true}
                  Form_BehaviorOnLoad={this.props.Form_BehaviorOnLoad}
					        Form_BehaviorOnSave={this.props.Form_BehaviorOnSave}
                  Form_SecondaryIDName={this.props.Form_SecondaryIDName}
					        Form_SecondaryIDValue={this.props.Form_SecondaryIDValue}
                  widgetsQA={this.props.widgetsQA}
                  preloadFormData={this.props.preloadFormData}
                  Question_ID={(this.props.widgetsQA.filter((w) => w.Widget_ID == parseInt(col.Column_Widget_ID)))[0].Question_ID || null}
                />
              )}
            </div>
          ))
          }
      </div>
    );
  }
}

export default RowViewer;
